import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  private settingsActive: boolean = false;
  private settingsActiveSubject = new Subject<boolean>();
  settingsActive$: Observable<boolean> = this.settingsActiveSubject.asObservable();

  constructor() { }

  launchSettings() {
    this.settingsActive = true;
    this.settingsActiveSubject.next(this.settingsActive);
  }

  closeSettings() {
    this.settingsActive = false;
    this.settingsActiveSubject.next(this.settingsActive);
  }

  isSettingsActive(): boolean {
    return this.settingsActive;
  }
}
